import { render, staticRenderFns } from "./ChirpSettings.vue?vue&type=template&id=582f8f44"
import script from "./ChirpSettings.vue?vue&type=script&lang=js"
export * from "./ChirpSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports